import { render, staticRenderFns } from "./SelectGapQuestion.vue?vue&type=template&id=034e0598&scoped=true"
import script from "./SelectGapQuestion.vue?vue&type=script&lang=js"
export * from "./SelectGapQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034e0598",
  null
  
)

export default component.exports